import styled from "styled-components";
import Button from "@alboompro/boom-components/general/button";

export const ButtonWrapper = styled(Button)`
  user-select: none;
`;

export const EditorPanelContainer = styled.div`
  padding: 0;

  > button {
    &:focus {
      outline: none;
    }
  }
`;
